module.exports = __webpack_public_path__ + "static/img/龙头雷达.f5ae9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/龙头雷达.png
// module id = wzLI
// module chunks = 1